import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'twitter-third-party-glyph-icon'

export function TwitterSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 26 26">
      <g>
        <path d="M15.4735 11.0092L25.1526 0H22.859L14.4546 9.55916L7.74211 0H0L10.1507 14.4551L0 26H2.29376L11.169 15.9052L18.2579 26H26L15.473 11.0092H15.4735ZM12.3319 14.5825L11.3034 13.1431L3.12024 1.68958H6.64332L13.2473 10.9329L14.2757 12.3723L22.8601 24.3873H19.337L12.3319 14.583V14.5825Z" />
      </g>
    </symbol>
  )
}

const TwitterStandaloneContent = standalone(TwitterSymbol, ID)

export const Twitter = styled(function TwitterStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-twitter">
      <TwitterStandaloneContent />
    </Icon>
  )
})`
  transform: scale(0.76);
  transform-origin: center;
`

export const TwitterLightweight = styled(function TwitterComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-twitter">
      {lightweight(ID)}
    </Icon>
  )
})`
  transform: scale(0.76);
  transform-origin: center;
`
